// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import vueRouter from 'vue-router'
import Vuelidate from 'vuelidate'
import EventHub from './plugins/EventHub'
import FetchPlugin from './plugins/Fetch'
import NotifierPlugin from './plugins/Notifier'
// import VueAMap from 'vue-amap'
import Element from 'element-ui'
// import echarts from 'echarts'
import global from './plugins/global'
import CyFilter from './mixins/utilities/filter'
import 'element-ui/lib/theme-chalk/index.css'
import './stylus/app.styl'
import Filter from '@/filters/index'

// 引入基本模板
var echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/pie')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')

Vue.prototype.$echarts = echarts

// require('./assets/detect/download-chrome-win7-1.jpg')
// require('./assets/detect/download-chrome-win7-2.jpg')
// require('./assets/detect/download-chrome-win8-1.jpg')
// require('./assets/detect/download-chrome-win8-2.jpg')
// require('./assets/detect/download-chrome-win8-3.jpg')
// require('./assets/detect/download-chrome-win10-1.jpg')
// require('./assets/detect/download-chrome-win10-2.jpg')
// require('./assets/detect/download-chrome-win10-3.jpg')
// require('./assets/detect/download-firefox-1.jpg')
// require('./assets/detect/download-firefox-2.jpg')

Vue.prototype.$global = global
// 处理vue-router重复跳转当前路由引起的报错
const originalPush = vueRouter.prototype.push
vueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

// use vue router
Vue.use(vueRouter)


Vue.use(Filter) // 全局过滤器注册
// use Vuelidate
Vue.use(Vuelidate)

// use event hub
Vue.use(EventHub)

// use map
// Vue.use(VueAMap)

// use fetch plugin
Vue.use(FetchPlugin)

// use notifier plugin
Vue.use(NotifierPlugin)

// use element-tree
Vue.use(Element)

// 使用自定义过滤器
Vue.use(CyFilter)

// window._AMapSecurityConfig = {
//   securityJsCode: '463edc7b7cc920e55d40b474486d1d96',
// }
// VueAMap.initAMapApiLoader({
//   key: 'a73fe8b279b1c3c09a0a669b40f42acc',
//   plugin: ['Geocoder'],
//   v: '1.4.15',
//   // plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor']
// })

Vue.config.productionTip = true


/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
})



// WEBPACK FOOTER //
// ./src/main.js